/**
 * Selos de reserva. A mesma regra dos selos de frota: cor NUNCA comunica
 * sozinha — todo selo tem rótulo, e o rótulo vem de `@locaveri/shared`, a
 * mesma string que a API valida. O amarelo é marca, não status: nenhum estado
 * da máquina usa a variante `brand`.
 */

import {
  ROTULO_DO_STATUS_DE_RESERVA,
  type IntencaoDoStatus,
  type StatusDaReserva,
} from '@locaveri/shared'
import type { ReactElement } from 'react'

import { Badge, type BadgeProps } from '@/components/ui/badge'

const VARIANTE_DA_INTENCAO = {
  positiva: 'success',
  informativa: 'info',
  neutra: 'neutral',
  atencao: 'warning',
  critica: 'danger',
} as const satisfies Readonly<Record<IntencaoDoStatus, NonNullable<BadgeProps['variant']>>>

export function BadgeDeStatusDeReserva({
  status,
}: {
  readonly status: StatusDaReserva
}): ReactElement {
  const { rotulo, intencao } = ROTULO_DO_STATUS_DE_RESERVA[status]
  return <Badge variant={VARIANTE_DA_INTENCAO[intencao]}>{rotulo}</Badge>
}

/** Escala do risco: baixo/médio/alto com o rótulo por extenso. */
export function BadgeDeRisco({
  score,
  nivel,
}: {
  readonly score: number
  readonly nivel: string
}): ReactElement {
  const variante: BadgeProps['variant'] =
    nivel === 'BAIXO' ? 'success' : nivel === 'MEDIO' ? 'warning' : 'danger'
  const rotulo =
    nivel === 'BAIXO' ? 'Risco baixo' : nivel === 'MEDIO' ? 'Risco médio' : 'Risco alto'
  return (
    <Badge variant={variante}>
      {rotulo} · {score}
    </Badge>
  )
}
